export default __webpack_public_path__ + "static/media/transfacil_galery_3.7e60cdf7.jpg";